import { Link } from "react-router-dom";
import { MapPin, Star, BedDouble, ArrowRight } from "lucide-react";
import { formatRupiah } from "@/components/property/roomMeta";
import { PROPERTY_TYPE_LABELS, GENDER_LABELS } from "@/components/property/PropertyStatusBadge";
import SanquaBadge from "@/components/property/SanquaBadge";

function priceLabel(card) {
  const v = card.min_price_monthly || card.min_price_daily || card.min_price_yearly;
  const suffix = card.min_price_monthly ? "/bln" : card.min_price_daily ? "/hari" : card.min_price_yearly ? "/thn" : "";
  if (!v) return { label: "Hubungi", suffix: "" };
  return { label: formatRupiah(v), suffix };
}

export default function MiniSitePropertyCard({ card, index = 0, testid }) {
  const price = priceLabel(card);
  return (
    <Link
      to={`/property/${card.id}`}
      data-testid={testid || `minisite-property-${index}`}
      className="group flex flex-col h-full bg-card border border-border rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-transform"
    >
      <div className="relative aspect-[4/3] bg-secondary/60 overflow-hidden">
        {card.cover_url ? (
          <img src={card.cover_url} alt={card.name} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full grid place-items-center text-xs text-muted-foreground">Foto hunian</div>
        )}
        <span className="absolute top-1.5 left-1.5 sm:top-2 sm:left-2 text-[9px] sm:text-[10px] font-bold uppercase tracking-wider rounded-full bg-primary text-primary-foreground px-2 py-0.5 sm:px-2.5 sm:py-1">
          {PROPERTY_TYPE_LABELS[card.property_type] || card.property_type}
        </span>
        {card.sanqua_partner && (
          <span className="absolute top-1.5 right-1.5 sm:top-2 sm:right-2"><SanquaBadge size="sm" testid={`minisite-sanqua-${index}`} /></span>
        )}
      </div>
      <div className="p-3 sm:p-5 flex flex-col flex-1">
        <h3 className="font-heading font-semibold text-sm sm:text-lg truncate" data-testid={`minisite-property-name-${index}`}>{card.name}</h3>
        <p className="mt-1 flex items-center gap-1 text-xs sm:text-sm text-muted-foreground truncate">
          <MapPin size={12} className="shrink-0" /> {[card.district_name, card.city_name].filter(Boolean).join(", ") || "—"}
        </p>
        <div className="mt-2 sm:mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] sm:text-xs text-muted-foreground">
          <span className="inline-flex items-center gap-1"><Star size={12} className="text-accent fill-accent" /> {card.rating || "—"}</span>
          <span className="hidden sm:inline">·</span>
          <span className="hidden sm:inline">{GENDER_LABELS[card.gender_type] || card.gender_type}</span>
          <span className="hidden sm:inline">·</span>
          <span className={card.available_count > 0 ? "text-emerald-600 font-medium inline-flex items-center gap-1" : "inline-flex items-center gap-1"}>
            <BedDouble size={12} /> {card.available_count > 0 ? `${card.available_count} tersedia` : "Penuh"}
          </span>
        </div>
        <div className="mt-auto pt-3 flex items-end justify-between border-t border-border mt-3">
          <div className="min-w-0">
            <span className="font-heading font-bold text-primary text-base sm:text-xl">{price.label}</span>
            {price.suffix && <span className="text-[10px] sm:text-xs text-muted-foreground"> {price.suffix}</span>}
          </div>
          <span className="hidden sm:inline-flex items-center gap-1 text-sm font-semibold text-accent shrink-0">Pesan <ArrowRight size={14} /></span>
        </div>
      </div>
    </Link>
  );
}
